(function() {
  define('bazemont/newsletter/editorial/editorial',['angular', 'angularLocaleFr', 'angularSanitize'], function() {
    'use strict';
    return angular.module('bazemontNewsletterEditorial', ['ui.bootstrap', 'ngSanitize']).component('bazemontNewsletterEditorial', {
      templateUrl: '/assets/javascripts/bazemont/newsletter/editorial/editorial.html',
      bindings: {
        id: '@',
        duplicateUrl: '@',
        deleteUrl: '@'
      },
      controller: [
        '$http', '$scope', 'NewsletterEditorial', 'TlhNotificationService', '$uibModal', 'TlhConfirmModalService', '$window', function($http, $scope, NewsletterEditorial, TlhNotificationService, $uibModal, TlhConfirmModalService, $window) {
          var handleEditorialChange, initialValue, preselectCategory, toolbarButtons, vm;
          vm = this;
          initialValue = null;
          vm.today = new Date();
          vm.edited = false;
          vm.saving = false;
          vm.$onInit = function() {
            return $http.get('/api/user-categories', {
              cache: true
            }).then(function(response) {
              vm.categories = response.data.categories;
              vm.isAdmin = response.data.isAdmin;
              if (vm.id > 0) {
                return NewsletterEditorial.get({
                  id: vm.id
                }, function(result) {
                  vm.editorial = result;
                  initialValue = angular.copy(vm.editorial);
                  return preselectCategory();
                });
              } else {
                return preselectCategory();
              }
            });
          };
          preselectCategory = function() {
            var category, _i, _len, _ref, _results;
            if (vm.editorial && vm.editorial.category) {
              _ref = vm.categories;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                category = _ref[_i];
                if (category.id === vm.editorial.category.id) {
                  vm.editorial.category = category;
                  break;
                } else {
                  _results.push(void 0);
                }
              }
              return _results;
            } else if (vm.categories.length === 1) {
              if (vm.editorial) {
                return vm.editorial.category = vm.categories[0];
              } else {
                return vm.editorial = {
                  category: vm.categories[0]
                };
              }
            }
          };
          vm.save = function(openTestModal) {
            vm.saving = true;
            TlhNotificationService.info({
              message: 'Enregistrement en cours...',
              delay: false
            });
            return new NewsletterEditorial(vm.editorial).$save().then(function(response) {
              if (response.success) {
                initialValue = angular.copy(response.editorial);
                vm.editorial = angular.copy(initialValue);
                preselectCategory();
                TlhNotificationService.success({
                  message: 'Enregistrement terminé',
                  replaceMessage: true
                });
                if (openTestModal) {
                  return vm.openTestModal();
                }
              }
            })["catch"](function(error) {
              var message;
              message = "L'enregistrement a échoué :<br>";
              message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
              TlhNotificationService.error({
                message: message,
                replaceMessage: true,
                delay: false
              });
              return console.error(error);
            })["finally"](function() {
              return vm.saving = false;
            });
          };
          vm.openTestModal = function() {
            var testModal;
            if (!angular.equals(vm.editorial, initialValue)) {
              return vm.save(true);
            } else {
              testModal = $uibModal.open({
                templateUrl: '/assets/javascripts/bazemont/newsletter/editorial/test-send-modal.html',
                controllerAs: '$ctrl',
                bindToController: true,
                backdrop: 'static',
                resolve: {
                  data: {
                    editorialId: vm.editorial.id,
                    isAdmin: vm.isAdmin
                  }
                },
                controller: [
                  '$uibModalInstance', 'data', '$http', function($uibModalInstance, data, $http) {
                    var mvm;
                    mvm = this;
                    mvm.isAdmin = data.isAdmin;
                    mvm.sendTestEmail = function() {
                      var postData;
                      TlhNotificationService.info({
                        message: 'Envoi en cours...',
                        delay: false
                      });
                      mvm.sending = true;
                      mvm.error = null;
                      postData = {
                        id: data.editorialId,
                        emails: mvm.emails
                      };
                      return $http.post('/api/admin/newsletter/editorial/send/try?id=' + postData.id, postData).then(function(response) {
                        TlhNotificationService.success({
                          message: 'Envoi terminé',
                          replaceMessage: true
                        });
                        return $uibModalInstance.close();
                      })["catch"](function(error) {
                        var message;
                        console.log(error);
                        message = "L'envoi a échoué :<br>";
                        if (error.data) {
                          mvm.error = error.data;
                          message += error.data;
                        } else {
                          message += "Erreur inattendue, veuillez contacter l'administrateur.";
                        }
                        return TlhNotificationService.error({
                          message: message,
                          replaceMessage: true,
                          delay: false
                        });
                      })["finally"](function() {
                        return mvm.sending = false;
                      });
                    };
                    mvm.notifyAdmin = function() {
                      TlhNotificationService.info({
                        message: 'Envoi de la demande en cours...',
                        delay: false
                      });
                      mvm.sending = true;
                      mvm.error = null;
                      return $http.post('/api/admin/newsletter/editorial/notify-admins/' + data.editorialId).then(function(response) {
                        TlhNotificationService.success({
                          message: 'Demande envoyée',
                          replaceMessage: true
                        });
                        return $uibModalInstance.close();
                      })["catch"](function(error) {
                        var message;
                        console.log(error);
                        message = "L'envoi a échoué :<br>";
                        if (error.data) {
                          mvm.error = error.data;
                          message += error.data;
                        } else {
                          message += "Erreur inattendue, veuillez contacter l'administrateur.";
                        }
                        return TlhNotificationService.error({
                          message: message,
                          replaceMessage: true,
                          delay: false
                        });
                      })["finally"](function() {
                        return mvm.sending = false;
                      });
                    };
                    mvm.skip = function() {
                      return $uibModalInstance.close();
                    };
                    mvm.cancel = function() {
                      return $uibModalInstance.dismiss('cancel');
                    };
                  }
                ]
              });
              return testModal.result.then(function() {
                if (vm.isAdmin) {
                  return vm.openLaunchModal();
                }
              });
            }
          };
          vm.openLaunchModal = function() {
            var launchModal;
            launchModal = $uibModal.open({
              templateUrl: '/assets/javascripts/bazemont/newsletter/editorial/send-modal.html',
              controllerAs: '$ctrl',
              bindToController: true,
              backdrop: 'static',
              resolve: {
                data: {
                  editorial: vm.editorial
                }
              },
              controller: [
                '$uibModalInstance', 'data', '$window', '$http', function($uibModalInstance, data, $window, $http) {
                  var mvm;
                  mvm = this;
                  mvm.editorial = data.editorial;
                  mvm.send = function() {
                    var postData;
                    TlhNotificationService.info({
                      message: 'Envoi en cours...',
                      delay: false
                    });
                    mvm.sending = true;
                    postData = {
                      id: mvm.editorial.id
                    };
                    return $http.post('/api/admin/newsletter/editorial/send/launch?id=' + postData.id, postData).then(function(response) {
                      return $uibModalInstance.close('sending');
                    })["catch"](function(error) {
                      var message;
                      console.log(error);
                      message = "L'envoi a échoué :<br>";
                      message += error.data ? error.data : "Erreur inattendue, veuillez contacter l'administrateur.";
                      return TlhNotificationService.error({
                        message: message,
                        replaceMessage: true,
                        delay: false
                      });
                    })["finally"](function() {
                      return mvm.sending = false;
                    });
                  };
                  mvm.back = function() {
                    return $uibModalInstance.close('back');
                  };
                  mvm.cancel = function() {
                    return $uibModalInstance.dismiss('cancel');
                  };
                }
              ]
            });
            return launchModal.result.then(function(result) {
              if (result === 'back') {
                return vm.openTestModal();
              } else if (result === 'sending') {
                return $window.location.href = '/admin/newsletters';
              }
            });
          };
          vm["delete"] = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer cette newsletter ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              if (result.confirm) {
                return $window.location.href = vm.deleteUrl;
              }
            });
          };
          toolbarButtons = ['bold', 'italic', 'underline', 'strikeThrough', '|', 'paragraphFormat', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '|', 'insertLink', 'insertImage', 'insertFile', 'insertTable', 'insertHR', '|', 'undo', 'redo', 'clearFormatting', 'selectAll'];
          vm.editorConfig = {
            pluginsEnabled: ['align', 'draggable', 'file', 'image', 'lineBreaker', 'link', 'lists', 'quote', 'table', 'url'],
            imageDefaultAlign: 'left',
            imageDefaultDisplay: 'inline',
            toolbarStickyOffset: 50,
            toolbarButtons: toolbarButtons,
            toolbarButtonsMD: toolbarButtons,
            toolbarButtonsSM: toolbarButtons,
            toolbarButtonsXS: toolbarButtons,
            enter: $.FroalaEditor.ENTER_BR
          };
          $window.onbeforeunload = function() {
            var result;
            result = void 0;
            if (vm.edited) {
              result = 'En quittant cette page, vous perdrez vos modifications non enregistrées.';
            }
            return result;
          };
          handleEditorialChange = function(newValue, oldValue) {
            if (newValue !== oldValue) {
              if (!vm.edited && !angular.equals(newValue, initialValue)) {
                vm.edited = true;
              }
              if (vm.edited && angular.equals(newValue, initialValue)) {
                return vm.edited = false;
              }
            }
          };
          $scope.$watch(function() {
            return vm.editorial;
          }, handleEditorialChange, true);
        }
      ]
    }).filter('dateWithSuffix', [
      '$filter', function($filter) {
        return function(input) {
          var day;
          day = $filter('date')(input, 'd');
          if (day === '1') {
            day += 'er';
          }
          return day + $filter('date')(input, ' MMMM y');
        };
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=editorial.js.map
;
